import { Collection, isImmutable, Map } from 'immutable';
import { applyMiddleware, compose, createStore as reduxCreateStore, Reducer } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { crashReporterMiddleware } from '../middleware/crashReporterMiddleware';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const toJS = (value: unknown): unknown => {
  if (isImmutable(value)) {
    const coll = value as Collection<unknown, unknown>;
    const size = (coll as any).size as number | undefined;

    if (typeof size === 'number' && size > 3000) {
      return `Collection of ${size} items, skipping.`;
    }

    return (coll as any)
      .toSeq()
      .map((item: unknown) => toJS(item))
      .toJS();
  }

  return value;
};

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
const loggerMiddleware = createLogger({
  stateTransformer: (state) => toJS(state),
  titleFormatter: (action, time, took) => `${action.type} @ ${time} (in ${took.toFixed(2)} ms)`,
  duration: true,
  collapsed: (state, action) => !action.error,
  level: (action) => {
    return action.error ? 'error' : 'info';
  },
});

export const createStore = (reducer: Reducer, sagas: () => Generator, history = null) => {
  const sagaMiddleware = createSagaMiddleware({
    onError: handleSagaError,
    context: { history },
  });
  const middleWares = [
    sagaMiddleware,
    //loggerMiddleware,
    crashReporterMiddleware,
  ];
  const finalMiddleWares = middleWares.filter((middleWare) => middleWare != null);

  const environment = import.meta.env.MODE;
  let store;
  if (environment === 'production') {
    store = reduxCreateStore(reducer, Map(), applyMiddleware(...finalMiddleWares));
  } else {
    // The Redux DevTools browser extension injects this global; without it we fall back to plain compose
    const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?? compose;
    store = reduxCreateStore(reducer, Map(), composeEnhancers(applyMiddleware(...finalMiddleWares)));
  }

  sagaMiddleware.run(sagas);
  return store;
};

const handleSagaError = (error: Error) => {
  console.error('Error logged by Saga error handler:', error);
};
